import {getTemplate} from "../utils";
import {renderElement} from "../../utils/common";

class NotificationItem {
  element: HTMLElement;
  private new = false;
  private id: number;
  private projectId: number;

  constructor({id, projectId, isNew}: {id: number, projectId: number, isNew: boolean}) {
    this.id = id;
    this.projectId = projectId;
    this.isNew = isNew;
  }

  get isNew(): boolean {
    return this.new;
  };

  set isNew(isNew: boolean) {
    this.new = isNew;
  }

  renderElement(parent: HTMLElement,
    options: {id: any; name: any; projectName: any; user: any; date: any; taskId: any; type: string},
    isSublist: boolean, isPrepend: boolean) {
    if (!this.isNew) {
      throw new Error(`Элемент уже существует`);
    }

    this.element = renderElement(parent, getTemplate(options.type)!(options, isSublist), isPrepend) as HTMLElement;
  }

  removeElement() {
    this.element.remove();
  }
}

export default NotificationItem;
